import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DemoHeader = ({ onRestart }) => {
  const [domain, setDomain] = useState('Healthcare');

  return (
    <div className="demo-header">
      <button className="demo-restart-btn" onClick={onRestart}>
        Restart
      </button>
      <div className="demo-domain-dropdown">
        <select 
          value={domain} 
          onChange={(e) => setDomain(e.target.value)}
          className="demo-domain-select"
        >
          <option value="Healthcare">Healthcare</option>
        </select>
      </div>
      <Link 
        to="/demo-live" 
        className="demo-restart-btn"
        style={{ 
          marginLeft: 'auto', 
          backgroundColor: '#4caf50',
          textDecoration: 'none'
        }}
      >
        Try Live Chat →
      </Link>
    </div>
  );
};

export default DemoHeader;

